import request from '@/utils/request'

export function login(username, password,code,sid) {
  return request({
    url: '/acc/login',
    method: 'post',
    data: {
      username,
      password,code,sid
    }
  })
}
export function getEmployer(params) {
  return request({
    url: '/index/getEmployer',
    method: 'get',
    params: params
  })
}
export function getEmployerCache(params) {
  return request({
    url: '/index/getEmployerCache',
    method: 'get',
    params: params
  })
}


export function listcateall(params) {
  return request({
    url: '/valuescode/listCateAll',
    method: 'get',
    params: params
  })
}

export function register(username, password,code) {
  return request({
    url: '/acc/register',
    method: 'post',
    data: {
      username,
      password,
      code
    }
  })
}

export function getPassCode() {
  return request({
    url: '/acc/getPassCode',
    method: 'get',
    responseType: "blob",
  })
}

export function getCaptcha(data) {
  return request({
    url: '/acc/getCaptcha',
    method: 'post',
    data: data
  })
}

export function getInfo() {
  return request({
    url: '/acc/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/acc/logout',
    method: 'post'
  })
}


export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function updatePassWord(data) {
  return request({
    url: '/acc/updatePassword',
    method: 'post',
    data: data
  })
}

export function resetPassword(data) {
  return request({
    url: '/acc/resetPassword',
    method: 'post',
    data: data
  })
}


export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}


export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}
export function getCodeImg() {
  return request({
    url: '/admin/getCode',
    method: 'get'
  })
}

export function passwordExpired() {
  return request({
    url: '/acc/passwordExpired',
    method: 'get',
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js